import { useState } from "react";
import BanerDashboard from "../BanerDashboard/BanerDarshboard";
import ContentTab from "./ContentTab/ContentTab";
import ScreenFreeContent from "./ScreenFreeContent/ScreenFreeContent";
import FilterFreeContent from "./FilterFreeContent/FilterFreeContent";
import filterItem from "../../Data/DataFilterFreeContent";

function FreeContent({ AddNewContent, OpenFilter }) {

    const [activeTab, setActiveTab] = useState(0)

    const chooseActiveTab = (value) => {
        setActiveTab(value)
        filterItem.socialNetwork = ""
        filterItem.title = ""
        filterItem.link = ""
        filterItem.description = ""
    }

    return (
        <>
            <BanerDashboard
                text="مدیریت محتوای آزاد"
            />
            <ContentTab
                activeTab={activeTab}
                chooseActiveTab={chooseActiveTab}
            />
            <FilterFreeContent AddNewContent={AddNewContent} OpenFilter={OpenFilter} />
            <div className="h-screen overflow-hidden bg-garyLight w95 border border-slate-200 mt-1 m-4 p-5 rounded-lg relative">
                <img src="/image/imageBG02.png" />
                <ScreenFreeContent
                    activeTab={activeTab}
                />
            </div>
        </>
    )
}
export default FreeContent;